import { render } from "./SpotBalanceActionGraphWidgetParams.vue?vue&type=template&id=510f6531"
import script from "./SpotBalanceActionGraphWidgetParams.vue?vue&type=script&lang=js"
export * from "./SpotBalanceActionGraphWidgetParams.vue?vue&type=script&lang=js"
script.render = render

export default script